export class IAsyncStorageStrategy {
}
//# sourceMappingURL=IAsyncStorageStrategy.js.map